import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { SidemenuComponent } from './components/layout/sidemenu/sidemenu.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { LoginComponent } from './components/site/login/login.component';
import { HomeComponent } from './components/site/home/home.component';
import { OrdersComponent } from './components/site/orders/orders.component';
import { OrderDetailsComponent } from './components/site/order-details/order-details.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import { ClientServiceService } from './shared/client-service.service';
import { ResetPasswordComponent } from './components/site/reset-password/reset-password.component';
import { SignatureComponent } from './components/site/signature/signature.component';
import { AgreementComponent } from './components/site/agreement/agreement.component';
import { ThankYouComponent } from './components/site/thank-you/thank-you.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidemenuComponent,
    FooterComponent,
    LoginComponent,
    HomeComponent,
    OrdersComponent,
    OrderDetailsComponent,
    ResetPasswordComponent,
    SignatureComponent,
    AgreementComponent,
    ThankYouComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
	  FormsModule
  ],
  providers: [ClientServiceService],
  bootstrap: [AppComponent]
})
export class AppModule { }
